import { render, staticRenderFns } from "./percentage.vue?vue&type=template&id=7a4831cc&scoped=true&"
import script from "./percentage.vue?vue&type=script&lang=js&"
export * from "./percentage.vue?vue&type=script&lang=js&"
import style0 from "./percentage.vue?vue&type=style&index=0&id=7a4831cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4831cc",
  null
  
)

export default component.exports